module.exports = __webpack_public_path__ + "img/HeadlineHazeLogo.15e0f308.png";